import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { PublicService } from '../shared/serviceLayer/public-service';
import { BuyerService } from '../shared/serviceLayer/buyer-service';
import { SharedService } from '../shared/serviceLayer/shared.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DataServiceService } from '../shared/serviceLayer/data-service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationDialogComponent } from '../shared/confirmation-dialog/confirmation-dialog.component';
import { ConfirmdialogServiceService } from '../shared/confirmation-dialog/confirmdialog-service.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { SharedApiService } from '../shared/serviceLayer/shared-service';

@Component({
  standalone: false,
  selector: 'app-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styleUrls: ['./vehicle-details.component.scss'],
})
export class VehicleDetailsComponent implements OnInit, AfterViewInit {
    @ViewChild('callAPIDialog2') callAPIDialog2: TemplateRef<any>;
    dialogRef: BsModalRef<any>;
  viewInteriorVedio = signal<boolean>(false);
  viewExteriorVedio = signal<boolean>(false);
  @ViewChild('callAPIDialog') callAPIDialog: TemplateRef<any>;
  modalRef: BsModalRef;
  screenWidth = signal<number>(0);
  vechicleId: any;
  vehicleDetails = signal<any>({inventoryStatus: 3, auctionVehicleStatus: 'sold', isLoading: false});
  showVehicle = signal<any>(undefined);
  inventoryList = signal<any[]>([]);
  customBid = signal<any>(undefined);
  defaultImagCar: any;
  currentUser: any;
  bidHistory = signal<any>(undefined);
  auctionDetail = signal<any>(null);
  isAuctionVehicle = signal<boolean>(false);
  isNextCarAvailable = signal<any>(undefined);
  isPreviousCarAvailable = signal<any>(undefined);
  startingBid = signal<number>(0);
  latestBidAmount = signal<number>(0);

  activeTab = signal<string>('vehicleInfo');

  constructor(
    private router: ActivatedRoute,
    private publicService: PublicService,
    private buyerService: BuyerService,
    private sharedApiService: SharedApiService,
    private toastr: ToastrService,
    private route: Router,
    private dialogService: ConfirmdialogServiceService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private confirmationDialog: ConfirmdialogServiceService,
    public sharedService: SharedService,
    private translate: TranslateService,
    private location: Location,
    private meta: Meta,
    private title: Title,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    const nav = this.route.getCurrentNavigation();
  const state = nav?.extras?.state;

  if (state) {
    this.vechicleId = state['id'];
  }
  }
 ngOnInit(): void {
    this.onResize();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.router.params.subscribe(params => {
    const yearAndId = params['yearAndId'];

    const firstDash = yearAndId.indexOf('-');
    const id = firstDash !== -1 ? yearAndId.substring(firstDash + 1) : yearAndId;
    this.vechicleId = id;
    if (this.vechicleId) {
      this.getInventoryList(this.vechicleId);
    } else {
      // Optional fallback: fetch using make/model/year
      console.warn('No car ID found in sessionStorage');
    }
  });

    this.defaultImagCar = this.sharedService.getImage();
    window.addEventListener('keydown', (e) => {
      let key = e.keyCode;
      let src = (<HTMLInputElement>document.getElementById('myimage')).src;
      if (key == 39) {
        //forward
        let index = 0;
        for (var i of this.vehicleDetails()?.vinimages) {
          if (i?.image == src) {
            let pos = index + 1;
            if (pos > this.vehicleDetails()?.vinimages.length - 1) {
              pos = 0;
              this.showVehicle.set(this.vehicleDetails()?.vinimages[pos].image);
            } else {
              this.showVehicle.set(this.vehicleDetails()?.vinimages[pos].image);
            }
          }
          index++;
        }
      }

      if (key == 37) {
        // backward

        let index = 0;
        for (var i of this.vehicleDetails()?.vinimages) {
          if (i?.image == src) {
            let pos = index - 1;
            if (pos < 0) {
              pos = this.vehicleDetails()?.vinimages.length - 1;
              this.showVehicle.set(this.vehicleDetails()?.vinimages[pos].image);
            } else {
              this.showVehicle.set(this.vehicleDetails()?.vinimages[pos].image);
            }
          }
          index++;
        }
      }
    });
  }

  ngAfterViewInit(): void {
      // sessionStorage.removeItem('selectedCarId');
  }

  changeTab(tabName: string) {
    this.activeTab.set(tabName);
  }
  @HostListener('window:resize')
  onResize() {
    this.screenWidth.set(window.innerWidth);
    this.chunkVehicleList();
  }
  chunkVehicleList(): void {
    const chunkSize =
      window.innerWidth >= 1600
        ? 4
        : window.innerWidth >= 990
        ? 4
        : window.innerWidth >= 740
        ? 3
        : window.innerWidth >= 570
        ? 2
        : 1;
    const chunks: any[] = [];
    for (let i = 0; i < this.inventoryList().length; i += chunkSize) {
      chunks.push(this.inventoryList().slice(i, i + chunkSize));
    }
    this.chunkedVehicleList.set(chunks);
  }
  nextImage() {
    let src = (<HTMLInputElement>document.getElementById('myimage')).src;
    let index = 0;
    let allimg = this.filterImage(this.vehicleDetails()?.vinimages);
    for (var i of allimg) {
      if (i?.image?.split('/assets/').pop() == src?.split('/assets/').pop()) {
        let pos = index + 1;
        if (pos > allimg.length - 1) {
          pos = 0;
          this.showVehicle.set(allimg[pos].image);
        } else {
          this.showVehicle.set(allimg[pos].image);
        }
      }
      index++;
    }
  }

  previousImage() {
    let src = (<HTMLInputElement>document.getElementById('myimage')).src;
    let index = 0;
    let allimg = this.filterImage(this.vehicleDetails()?.vinimages);
    for (var i of allimg) {
      if (i?.image?.split('/assets/').pop() == src?.split('/assets/').pop()) {
        let pos = index - 1;
        if (pos < 0) {
          pos = allimg.length - 1;
          this.showVehicle.set(allimg[pos].image);
        } else {
          this.showVehicle.set(allimg[pos].image);
        }
      }
      index++;
    }
  }

  getAuctionDetail() {
    this.publicService
      .getAuctionDetail({ auctionId: this.vehicleDetails()?.auctionId })
      .subscribe((data: any) => {
        this.auctionDetail.set(data.data);
      });
  }

  getColor(code:any) {
    return code;
  }

  getInventoryList(id:string) {
    this.showVehicle.set(undefined);
    const data: any = {
      page: 1,
      pageLimit: 1,
      inventoryId: id,
      pagination: true,
      apiType: 'web',
      isInspectionNeeded: true,
    };
    if (this.currentUser) data['buyerId'] = this.currentUser?._id;
    this.publicService.getInventoryDetails(data).subscribe((res: any) => {
      if (res.status == true && res.data?.length > 0) {
        this.vehicleDetails.set(res.data[0]);
        this.setDynamicMetaTags();
        if (this.vehicleDetails()?.inspection) {
          const count = Object.values(this.vehicleDetails().inspection).filter(
            (item: any) => item.status === true
          ).length;
          if (count <= 3) {
            this.vehicleDetails.update(vd => ({...vd, inspection: null}));
          }
        }
        const startingBid = this.vehicleDetails()?.startingBid;
        this.customBid.set(startingBid + 500);
        this.bidHistory.set(null);
        this.getBidHIstory();
        if (this.vehicleDetails()?.inventoryStatus != 3 &&
            this.vehicleDetails()?.auctionVehicleStatus != 'sold') {
          this.getInventory();
        }
        this.isAuctionVehicle.set(!!this.vehicleDetails()?.auctionId);
        if (this.isAuctionVehicle()) this.getAuctionDetail();
        this.isNextCarAvailable.set(this.vehicleDetails()?.isNextCarAvailable);
        this.isPreviousCarAvailable.set(this.vehicleDetails()?.isPreviousCarAvailable);
        const vinimages = this.vehicleDetails()?.vinimages ?? [];
        if (vinimages.length <= 0) {
          vinimages.push({ image: vinimages[0] });
        }
        const filterimages = vinimages.filter((x: any) => x.type == 'carimage');
        this.showVehicle.set(filterimages.length > 0 ? filterimages[0].image : '');
        this.getInteriorVideo();
      }
      this.cdr.detectChanges();
    });
  }
  chunkedVehicleList = signal<any[]>([]);
  getInventory() {
    this.publicService
      .getAuctionVehicles({
        page: 1,
        pageLimit: 20,
        status: 2,
        apiType: 'web',
        isInspectionNeeded: true,
        auctionId: this.vehicleDetails()?.auctionId,
      })
      .subscribe((res: any) => {
        if (res.status == true) {
          this.inventoryList.set(res.data);
          this.chunkVehicleList();
        }
      });
  }

  chunkArray(arr:any, chunkSize:any) {
    let result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  }

  onClickImage(path: any) {
    this.showVehicle.set(path);
  }

  setDynamicMetaTags() {
    const year = this.vehicleDetails()?.year || '';
    const make = this.vehicleDetails()?.make || '';
    const model = this.vehicleDetails()?.model || '';

    // Get vehicle featured image from CloudFront
    const vehicleImageUrl = this.showVehicle() || this.vehicleDetails()?.singleImages || '';
    const ogImageUrl = vehicleImageUrl ? this.sharedService.cloudFrontUrl('1200x630', vehicleImageUrl) : '';
    const twitterImageUrl = vehicleImageUrl ? this.sharedService.cloudFrontUrl('1200x675', vehicleImageUrl) : '';

    // Set dynamic page title
    const pageTitle = `${year} ${make} ${model} For Sale | Alqaryah Auction`;
    this.title.setTitle(pageTitle);

    // Set dynamic meta description
    const metaDescription = `Buy ${year} ${make} ${model} at Al Qaryah Auction, View Photos Specifications, and sold price details. Trusted vehicle auctions in the UAE.`;
    this.meta.updateTag(
      { name: 'description', content: metaDescription }
    );

    // Set dynamic meta keywords
    const metaKeywords = `${year} ${make} ${model}, ${year} ${make} ${model} for sale, Alqaryah Auction, used cars UAE`;
    this.meta.updateTag(
      { name: 'keywords', content: metaKeywords }
    );

    // Set robots tag
    this.meta.updateTag(
      { name: 'robots', content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' }
    );

    // Set author tag
    this.meta.updateTag(
      { name: 'author', content: 'Al Qaryah Auction' }
    );

    // Set Open Graph tags for social media sharing (Facebook)
    this.meta.updateTag(
      { property: 'og:title', content: pageTitle }
    );
    this.meta.updateTag(
      { property: 'og:description', content: metaDescription }
    );
    this.meta.updateTag(
      { property: 'og:type', content: 'website' }
    );
    this.meta.updateTag(
      { property: 'og:url', content: isPlatformBrowser(this.platformId) ? window.location.href : '' }
    );
    if (ogImageUrl) {
      this.meta.updateTag(
        { property: 'og:image', content: ogImageUrl }
      );
      this.meta.updateTag(
        { property: 'og:image:width', content: '1200' }
      );
      this.meta.updateTag(
        { property: 'og:image:height', content: '630' }
      );
    }

    // Set Twitter Card tags
    this.meta.updateTag(
      { name: 'twitter:card', content: 'summary_large_image' }
    );
    this.meta.updateTag(
      { name: 'twitter:title', content: pageTitle }
    );
    this.meta.updateTag(
      { name: 'twitter:description', content: metaDescription }
    );
    this.meta.updateTag(
      { name: 'twitter:site', content: '@AlQaryahAuction' }
    );
    if (twitterImageUrl) {
      this.meta.updateTag(
        { name: 'twitter:image', content: twitterImageUrl }
      );
    }

    // Set canonical URL
    if (isPlatformBrowser(this.platformId)) {
      this.meta.updateTag(
        { rel: 'canonical', href: window.location.href }
      );
    }
  }

  addToWatchList() {
    this.sharedApiService
      .watchListAdd({
        inventoryId: this.vechicleId,
        buyerId: this.currentUser?._id,
        auctionId: this.vehicleDetails()?.auctionId,
      })
      .subscribe((res: any) => {
        if (res.status == true) {
          this.getInventoryList(this.vechicleId);
          this.toastr.success(this.translate.instant('tooltips.successfully-added'));
        }
      });
  }

  deleteWatchList(id:string) {
    if (id) {
      this.sharedApiService
        .deleteWatchList({ watchlistId: id })
        .subscribe((res: any) => {
          if (res.status == true) {
            this.getInventoryList(this.vechicleId);
            this.toastr.success(this.translate.instant('tooltips.successfully-removed'));
          }
        });
    } else {
      this.toastr.success('Please contact admin');
    }
  }

  decreaseVal(e: any) {
    let bidAmount = parseInt(
      (<HTMLInputElement>document.getElementById('pre-bid-val')).innerHTML
    );
    if (bidAmount > this.customBid()) {
      bidAmount = bidAmount - 500;
      (<HTMLInputElement>document.getElementById('pre-bid-val')).innerHTML =
        '' + bidAmount;
    }
  }

  increaseVal(e: any) {
    let bidAmount = parseInt(
      (<HTMLInputElement>document.getElementById('pre-bid-val')).innerHTML
    );
    if (bidAmount) {
      // if (bidAmount + 500 > this.currentUser?.creditLimit) {
      //   this.toastr.warning("you don't have enough credit ");
      //   return;
      // }
      // else {
        bidAmount = bidAmount + 500;
      // }
    } else {
      bidAmount = 500;
    }

    (<HTMLInputElement>document.getElementById('pre-bid-val')).innerHTML =
      '' + bidAmount;
  }

  showConfirmation(): void {
    const message = this.translate.instant('Withdraw-Orders.sure');
    const message1 = this.translate.instant(
      'Withdraw-Orders.you-declined-to-pre-bid'
    );
    const message2 = this.translate.instant('Withdraw-Orders.warning');
    const userReasonSubscription = this.confirmationDialog
      .showConfirmationDialog(
        message,
        this.translate.instant('vehicles.prebid'),
        { ok: false, cancel: true, confirm: true }
      )
      .subscribe((res: any) => {
        if (res) {
          this.preBid();
          userReasonSubscription.unsubscribe();
        } else {
          this.toastr.warning(message1, message2);
          userReasonSubscription.unsubscribe();
        }
      });
  }

  preBid() {
    const message = this.translate.instant(
      'Withdraw-Orders.you-dont-have-enough-credit'
    );
    if (this.currentUser?.userType === 4 || this.currentUser?.userType === 5) {
      let bidAmount = (<HTMLInputElement>document.getElementById('pre-bid-val'))
        .innerHTML;
      let reserve = parseInt(this.vehicleDetails()?.reservePrice);
      if (!bidAmount) {
        return;
      }
      // if (bidAmount) {
      //   if (bidAmount > this.currentUser?.creditLimit) {
      //     this.toastr.warning(message);
      //     return;
      //   }
      // }
      let currAmount = this.currentBidCalculation(bidAmount);
      let inventoryId = this.vehicleDetails()._id;
      let userId = this.currentUser._id;
      let userName = this.currentUser.name;

      this.buyerService
        .updatePreBid({
          currAmount: currAmount,
          inventoryId: inventoryId,
          userId: userId,
          userName: userName,
          bidStatus: 'Open',
          bidType: 'Pre',
          bidMode: 'online',
          calcAmount: parseInt(bidAmount),
          auctionId: this.vehicleDetails().auctionId,
          userUniqueIdentifier: this.currentUser.uniqueIdentifier,
        })
        .subscribe((res: any) => {
          if (res.status == true) {
            this.vehicleDetails.update(vd => ({...vd, reservePrice: parseInt(bidAmount)}));
            this.toastr.success(res.message);
            this.getBidHIstory();
            // location.reload();
            (<HTMLInputElement>(
              document.getElementById('pre-bid-val')
            )).innerHTML = '';
          } else {
            this.toastr.error(res.message);
          }
        });
    } else {
      this.openPopupAlert();
    }
  }

  currentBidCalculation(currentBidAmount:any) {
    if (this.latestBidAmount() === 0 && this.startingBid() === 0) {
      return currentBidAmount;
    }

    if (this.latestBidAmount() > 0 && this.startingBid() > 0) {
      return currentBidAmount - this.latestBidAmount();
    } else {
      return currentBidAmount - this.startingBid();
    }
  }
  // showResult = false;
  name = 'Angular';

  imageZoom1(imgID:any, resultID:any) {
    var img:any, lens:any, result:any, cx:any, cy:any;
    img = document.getElementById(imgID);
    result = document.getElementById(resultID);
    lens = document.createElement('DIV');
    lens.setAttribute('class', 'img-zoom-lens');
    img.parentElement.insertBefore(lens, img);
    cx = result.offsetWidth / lens.offsetWidth;
    cy = result.offsetHeight / lens.offsetHeight;
    result.style.backgroundImage = "url('" + img.src + "')";
    result.style.backgroundSize =
      img.width * cx + 'px ' + img.height * cy + 'px';
    lens.addEventListener('mousemove', moveLens);
    img.addEventListener('mousemove', moveLens);
    lens.addEventListener('touchmove', moveLens);
    img.addEventListener('touchmove', moveLens);
    function moveLens(e:any) {
      var pos, x, y;
      e.preventDefault();
      pos = getCursorPos(e);
      x = pos.x - lens.offsetWidth / 2;
      y = pos.y - lens.offsetHeight / 2;
      if (x > img.width - lens.offsetWidth) {
        x = img.width - lens.offsetWidth;
      }
      if (x < 0) {
        x = 0;
      }
      if (y > img.height - lens.offsetHeight) {
        y = img.height - lens.offsetHeight;
      }
      if (y < 0) {
        y = 0;
      }
      lens.style.left = x + 'px';
      lens.style.top = y + 'px';
      result.style.backgroundPosition = '-' + x * cx + 'px -' + y * cy + 'px';
    }
    function getCursorPos(e:any) {
      var a,
        x = 0,
        y = 0;
      e = e || window.event;
      a = img.getBoundingClientRect();
      x = e.pageX - a.left;
      y = e.pageY - a.top;
      x = x - window.pageXOffset;
      y = y - window.pageYOffset;
      return { x: x, y: y };
    }
  }

  imageZoom(imgID:any, resultID:any) {
    var img:any, lens:any, result:any, cx:any, cy:any;
    img = document.getElementById(imgID);
    result = document.getElementById(resultID);
    lens = document.createElement('DIV');
    lens.setAttribute('class', 'img-zoom-lens');
    img.parentElement.insertBefore(lens, img);
    cx = img.width / lens.offsetWidth;
    cy = img.height / lens.offsetHeight;
    result.style.backgroundImage = "url('" + img.src + "')";
    result.style.backgroundSize =
      img.width * cx + 'px ' + img.height * cy + 'px';
    lens.addEventListener('mousemove', moveLens);
    img.addEventListener('mousemove', moveLens);
    lens.addEventListener('touchmove', moveLens);
    img.addEventListener('touchmove', moveLens);
    img.addEventListener('mouseenter', showResult);
    img.addEventListener('mouseleave', hideResult);
    lens.addEventListener('mouseenter', showResult);
    lens.addEventListener('mouseleave', hideResult);

    function moveLens(e:any) {
      var pos, x, y;
      e.preventDefault();
      pos = getCursorPos(e);
      x = pos.x - lens.offsetWidth / 2;
      y = pos.y - lens.offsetHeight / 2;
      if (x > img.width - lens.offsetWidth) {
        x = img.width - lens.offsetWidth;
      }
      if (x < 0) {
        x = 0;
      }
      if (y > img.height - lens.offsetHeight) {
        y = img.height - lens.offsetHeight;
      }
      if (y < 0) {
        y = 0;
      }
      lens.style.left = x + 'px';
      lens.style.top = y + 'px';
      result.style.backgroundPosition = '-' + x * cx + 'px -' + y * cy + 'px';
    }
    function getCursorPos(e:any) {
      var a,
        x = 0,
        y = 0;
      e = e || window.event;
      a = img.getBoundingClientRect();
      x = e.pageX - a.left;
      y = e.pageY - a.top;
      x = x - window.pageXOffset;
      y = y - window.pageYOffset;
      return { x: x, y: y };
    }

    function showResult() {
      result.style.display = 'block';
    }

    function hideResult() {
      result.style.display = 'none';
    }
  }

  getBidHIstory() {
    this.bidHistory.set(undefined);
    let data = {
      bidStatus: 'Open',
      bidType: 'Pre',
      page: 1,
      pageLimit: 1000000,
      userId: this.currentUser?._id,
      vin: this.vehicleDetails()?.vin,
      auctionId: this.vehicleDetails()?.auctionId,
      inventoryId: this.vehicleDetails()?._id,
    };
    this.publicService.getPreBids(data).subscribe((res: any) => {
      if (res.status == true) {
        this.bidHistory.set(res.data[0]);
        let amt: any;
        if (this.bidHistory()) {
          if (this.bidHistory()?.bidDetails?.latestBidAmount) {
            this.latestBidAmount.set(this.bidHistory()?.bidDetails?.latestBidAmount);
            if (
              this.bidHistory()?.bidDetails?.latestBidAmount ==
                this.currentUser?.creditLimit ||
              this.bidHistory()?.bidDetails?.latestBidAmount >
                this.currentUser?.creditLimit
            ) {
              this.customBid.set(this.bidHistory()?.bidDetails?.latestBidAmount + 500);
              (<HTMLInputElement>(
                document.getElementById('pre-bid-val')
              )).innerHTML = this.customBid();
              return;
            } else {
              amt = this.bidHistory()?.bidDetails?.latestBidAmount + 500;
              this.customBid.set(amt);
            }
          } else {
            this.customBid.set(
              this.startingBid() > 0 ? this.startingBid() + 500 : 500
            );
          }
          (<HTMLInputElement>document.getElementById('pre-bid-val')).innerHTML =
            this.customBid();
        } else {
          this.customBid.set(this.vehicleDetails()?.startingBid + 500);
          (<HTMLInputElement>document.getElementById('pre-bid-val')).innerHTML =
            this.customBid();
        }
      }
    });
  }


  transform(end: Date): string {
    let formatedTime = this.datePipe.transform(end, 'yyyy-MM-dd HH:mm', 'UTC');
    let time = new Date(formatedTime);
    const timeDiff = time.getTime() - new Date().getTime();
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    const formattedTime = `${days}d ${hours}h ${minutes}m ${seconds}s`;

    this.cdr.markForCheck();
    if (seconds < 0) {
      return 'AUCTION STARTED';
    } else {
      return formattedTime;
    }
  }

  GetAuctionVehicleByDisplay(type: string) {
    let data:any = {
      auctionId: this.vehicleDetails()?.auctionId,
      displayNo: this.vehicleDetails()?.auctionDisplayNo,
      buyerId: this.currentUser?._id,
    };

    type == 'n' ? (data['next'] = true) : (data['previous'] = true);

    this.publicService.inventoryByAuctionDisplay(data).subscribe((data: any) => {
      this.vehicleDetails.set(data.data[0]);
      this.customBid.set(this.vehicleDetails()?.startingBid + 500);
      this.vechicleId = this.vehicleDetails()?._id;
      this.isNextCarAvailable.set(this.vehicleDetails()?.isNextCarAvailable);
      this.isPreviousCarAvailable.set(this.vehicleDetails()?.isPreviousCarAvailable);

      if (this.vehicleDetails()?.vinimages.length <= 0) {
        const vinimages = [...this.vehicleDetails().vinimages, { image: this.vehicleDetails()?.vinimages[0] }];
        this.vehicleDetails.update(vd => ({...vd, vinimages}));
      }

      this.bidHistory.set(null);
      this.getBidHIstory();
      this.showVehicle.set(this.vehicleDetails()?.vinimages[0]?.image);

      // Update the URL dynamically
      const newUrl = this.route
        .createUrlTree(
          [
            '/vehicle-details',
            this.formatUrlPart(this.vehicleDetails()?.make?.toLowerCase()),
            this.formatUrlPart(this.vehicleDetails()?.model?.toLowerCase()),
            `${this.vehicleDetails()?.year}-${this.vehicleDetails()?._id}`
          ]
        )
        .toString();

      window.history.pushState({}, '', newUrl); // Update the browser URL without reloading

      this.cdr.detectChanges();
    });
  }

navigateToVehicleDetails(car: any): void {
   // Scroll to top
  window.scrollTo({ top: 0, behavior: 'smooth' });
  const make = this.formatUrlPart(car?.make);
  const model = this.formatUrlPart(car?.model);
  const yearAndId = `${car?.year}-${car?._id}`;
  const newUrl = `/vehicle-details/${make}/${model}/${yearAndId}`;
  this.vechicleId = car?._id;
  this.getInventoryList(this.vechicleId);
  this.location.go(newUrl); // or use replaceState(newUrl) to avoid history entry
}

  formatUrlPart(value: string | null | undefined): string {
  return value ? value.toLowerCase().replace(/\s+/g, '-') : '';
}

  openPopupAlert() {


    const message = this.translate.instant('auctions.message1');
    this.dialogService.showWarningDialog(message);
  }

  zoomImageClick = signal<boolean>(false);
  onClickImageZoom() {
    this.zoomImageClick.update(v => !v);
  }
  capitalizeFirstLetter(word:any) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  lowercaseTitle(make:any, model:any, year:any) {
    const title = `${this.capitalizeFirstLetter(
      make
    )} ${this.capitalizeFirstLetter(model)} ${this.capitalizeFirstLetter(
      year
    )}`;
    return title;
  }
  formatCarMake(make: string): string {
    if (make) {
      return make.charAt(0).toUpperCase() + make.slice(1).toLowerCase();
    }
    return '';
  }

  filterImage(images: any) {
    return images?.filter((x: any) => x.type == 'carimage');
  }

  videos = signal<any[]>([]);
  getInteriorVideo() {
    const vids: any[] = [];
    for (var i of this.vehicleDetails().sellerVinImages) {
      if (i?.image?.endsWith('mp4')) {
        vids.push(i?.image);
      }
    }
    this.videos.set(vids);
  }
  engineVideoOpen = signal(false);
  private engineVideoCloseTimer: any;

  openEngineVideo(video: HTMLVideoElement) {
    clearTimeout(this.engineVideoCloseTimer);
    if (this.engineVideoOpen()) return;
    this.engineVideoOpen.set(true);
    video?.play().catch(() => {});
  }

  // Delay close so entering fullscreen (which fires mouseleave) can register first
  closeEngineVideo(video: HTMLVideoElement) {
    clearTimeout(this.engineVideoCloseTimer);
    this.engineVideoCloseTimer = setTimeout(() => {
      if (this.isEngineVideoFullscreen(video)) return;
      this.engineVideoOpen.set(false);
      video?.pause();
    }, 300);
  }

  // Close popover after user exits fullscreen
  onEngineVideoFullscreen(video: HTMLVideoElement) {
    if (!this.isEngineVideoFullscreen(video)) {
      this.closeEngineVideo(video);
    }
  }

  private isEngineVideoFullscreen(video: HTMLVideoElement) {
    return !!video && (document.fullscreenElement === video || (video as any).webkitDisplayingFullscreen);
  }

  openCleanTitlePDF() {
  if (this.vehicleDetails()?.clean_Title_pdf) {
    // Open PDF in a new tab
    window.open(this.vehicleDetails().clean_Title_pdf, '_blank');
  } else {
    // Show message if PDF not available
    Swal.fire({
      icon: 'info',
      title: 'PDF Not Available',
      text: 'There is no clean title PDF available for this vehicle.'
    });
  }
}

showTooltip = signal<boolean>(false);
tooltipData = signal<any>(null);

showStartTooltip(vehicle: any) {
  this.tooltipData.set({
    title: vehicle?.startCode?.title,
    description: vehicle?.startCode?.description
  });
  this.showTooltip.set(true);
}

hideStartTooltip() {
  this.showTooltip.set(false);
}

}

